<template>
  <div>
    <v-btn
      color="#803BE8"
      large
      fixed
      fab
      dark
      bottom
      right
      @click="formInsert = true"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <zp-modal-insert v-model="formInsert"></zp-modal-insert>
    <zp-modal-update v-model="formEdit" :id="formEditId"></zp-modal-update>
    <div v-if="loading && !pixels.length" style="height: 100%;" class="d-flex flex-column justify-center align-center">
      <v-progress-circular
        :width="3"
        :size="60"
        color="blue"
        indeterminate
      ></v-progress-circular>
      <strong class="mt-5">Carregando os seus pixels...</strong>
    </div>
    <zp-pixels-empty v-else-if="!pixels.length"></zp-pixels-empty>
    <v-data-table
      v-else
      :headers="headers"
      :items="pixels"
      :loading="loading"
      sort-by="created_at"
      :footer-props="{
        itemsPerPageText: 'Pixels por página:'
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Meus pixels</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="index()">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.name="{ item }">
        <strong>{{item.name}}</strong>
      </template>
      <template v-slot:item.token="{ item }">
        <div class="d-flex align-center" v-if="item.type === 'Facebook Pixel'">
          <v-icon color="green" small v-if="item.token">mdi-check-circle</v-icon>
          <v-icon color="grey" small v-else>mdi-close-circle</v-icon>
          <span class="caption ml-1">{{item.token ? 'Sim' : 'Não atribuído'}}</span>
        </div>
        <div v-else class="d-flex align-center">
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="grey lighten-1" v-bind="attrs" v-on="on" small class="mr-1">mdi-information</v-icon>
            </template>
            <span>Não há API de Conversão habilitada para este tipo de pixel</span>
          </v-tooltip>
          <span class="caption font-weight-light">Não possui</span>
        </div>
      </template>
      <template v-slot:item.type="{ item }">
        <div class="d-flex align-center">
          <div class="d-flex align-center mr-2">
            <img v-if="item.type === 'Google Analytics'" src="/img/ga.svg" style="width: 20px;" alt="Google Analytics">
            <img v-if="item.type === 'Facebook Pixel'" src="/img/fb.svg" style="width: 20px;" alt="Facebook Pixel">
            <img v-if="item.type === 'Google Tag Manager'" src="/img/gtm.svg" style="width: 20px;" alt="Google Tag Manager">
          </div>
          <span>{{item.type}}</span>
        </div>
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn small dark color="grey" icon @click="edit(item)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import ZpPixelsEmpty from '@/components/EmptyPixels'
import ZpModalInsert from '@/components/Pixel/Insert'
import ZpModalUpdate from '@/components/Pixel/Update'

export default {
  components: {
    ZpPixelsEmpty,
    ZpModalInsert,
    ZpModalUpdate
  },
  data () {
    return {
      formInsert: false,
      formEdit: false,
      formEditId: null,
      search: '',
      loading: false,
      copied: false,
      headers: [{
        text: 'Tipo',
        value: 'type'
      }, {
        text: 'Nome',
        value: 'name'
      }, {
        text: 'Identificador',
        value: 'identifier'
      }, {
        text: 'API de Conversão [BETA]',
        value: 'token'
      }, {
        text: 'Ação',
        value: 'action'
      }]
    }
  },
  computed: {
    ...mapState({
      data: state => state.pixels.data,
      user: state => state.auth.user
    }),
    pixels () {
      return this.data.filter(item => item.user_id === this.user.id)
    }
  },
  mounted () {
    this.index()
  },
  methods: {
    async index () {
      this.loading = true
      await this.$store.dispatch('pixels/index')
      this.loading = false
    },
    edit ({ id }) {
      this.formEdit = true
      this.formEditId = id
    }
  }
}
</script>

<style lang="scss" scoped>

</style>